/**
 * Auto-generated API method constants
 * DO NOT EDIT MANUALLY - Generated by scripts/extract-permissions.go
 *
 * Usage:
 * ```typescript
 * import { API_METHODS } from '@constants/api-methods';
 * const check = useAPIPermission(API_METHODS.AssetService.DownloadAsset);
 * ```
 */

export const API_METHODS = {
  AdminCallService: {
    AdminSearchCalls: 'AdminCallService.AdminSearchCalls',
    AdminUpdateCall: 'AdminCallService.AdminUpdateCall',
  },
  AdminCaseRecordService: {
    AdminSearchCaseRecords: 'AdminCaseRecordService.AdminSearchCaseRecords',
    AdminUpdateCaseState: 'AdminCaseRecordService.AdminUpdateCaseState',
    AdminUpdateSLA: 'AdminCaseRecordService.AdminUpdateSLA',
    AdminUpdateStatusFlags: 'AdminCaseRecordService.AdminUpdateStatusFlags',
  },
  AdminPayorService: {
    AdminCreatePayor: 'AdminPayorService.AdminCreatePayor',
    AdminGetPayor: 'AdminPayorService.AdminGetPayor',
    AdminUpdatePayor: 'AdminPayorService.AdminUpdatePayor',
  },
  AdminUserService: {
    ChangeEmail: 'AdminUserService.ChangeEmail',
    CopyUserPassword: 'AdminUserService.CopyUserPassword',
    DeactivateUser: 'AdminUserService.DeactivateUser',
    ReactivateUser: 'AdminUserService.ReactivateUser',
  },
  AdminWebhookService: {
    AdminBulkRetryWebhookDeliveries: 'AdminWebhookService.AdminBulkRetryWebhookDeliveries',
    AdminCreateWebhookEndpoint: 'AdminWebhookService.AdminCreateWebhookEndpoint',
    AdminDeleteWebhookEndpoint: 'AdminWebhookService.AdminDeleteWebhookEndpoint',
    AdminDisableWebhookEndpoint: 'AdminWebhookService.AdminDisableWebhookEndpoint',
    AdminGetWebhookDelivery: 'AdminWebhookService.AdminGetWebhookDelivery',
    AdminGetWebhookEndpoint: 'AdminWebhookService.AdminGetWebhookEndpoint',
    AdminGetWebhookEndpointHealth: 'AdminWebhookService.AdminGetWebhookEndpointHealth',
    AdminGetWebhookOperation: 'AdminWebhookService.AdminGetWebhookOperation',
    AdminListWebhookDeliveries: 'AdminWebhookService.AdminListWebhookDeliveries',
    AdminListWebhookEndpoints: 'AdminWebhookService.AdminListWebhookEndpoints',
    AdminPauseWebhookEndpoint: 'AdminWebhookService.AdminPauseWebhookEndpoint',
    AdminReplayWebhookWindow: 'AdminWebhookService.AdminReplayWebhookWindow',
    AdminResumeWebhookEndpoint: 'AdminWebhookService.AdminResumeWebhookEndpoint',
    AdminRetryWebhookDelivery: 'AdminWebhookService.AdminRetryWebhookDelivery',
    AdminRotateWebhookEndpointSecret: 'AdminWebhookService.AdminRotateWebhookEndpointSecret',
    AdminSendWebhookTestEvent: 'AdminWebhookService.AdminSendWebhookTestEvent',
    AdminUpdateWebhookEndpoint: 'AdminWebhookService.AdminUpdateWebhookEndpoint',
  },
  AnalyticsService: {
    GetAgentsList: 'AnalyticsService.GetAgentsList',
    GetAgentsSummary: 'AnalyticsService.GetAgentsSummary',
    GetOrgAnalytics: 'AnalyticsService.GetOrgAnalytics',
    GetQuestionDetail: 'AnalyticsService.GetQuestionDetail',
    GetQuestionEvaluations: 'AnalyticsService.GetQuestionEvaluations',
  },
  AppAnalyticsEventsService: {
    IngestAppEvents: 'AppAnalyticsEventsService.IngestAppEvents',
  },
  AssetService: {
    CreateAsset: 'AssetService.CreateAsset',
    DownloadAsset: 'AssetService.DownloadAsset',
    DownloadAssetFromArcus: 'AssetService.DownloadAssetFromArcus',
    DownloadCallConsoleAsset: 'AssetService.DownloadCallConsoleAsset',
    GetAsset: 'AssetService.GetAsset',
    ListAssets: 'AssetService.ListAssets',
    ListCallConsoleAssets: 'AssetService.ListCallConsoleAssets',
    UpdateAssetInArcus: 'AssetService.UpdateAssetInArcus',
  },
  AuditService: {
    CreateAuditFeedback: 'AuditService.CreateAuditFeedback',
    CreateCaseAuditFeedback: 'AuditService.CreateCaseAuditFeedback',
    GetAudit: 'AuditService.GetAudit',
    GetCaseAudit: 'AuditService.GetCaseAudit',
    ListAuditFeedback: 'AuditService.ListAuditFeedback',
    ListAudits: 'AuditService.ListAudits',
    ListCaseAuditFeedback: 'AuditService.ListCaseAuditFeedback',
    ListCaseAudits: 'AuditService.ListCaseAudits',
    UpdateAudit: 'AuditService.UpdateAudit',
    UpdateCaseAudit: 'AuditService.UpdateCaseAudit',
  },
  AuthService: {
    BeginMFAEnrollment: 'AuthService.BeginMFAEnrollment',
    CheckPasswordStrength: 'AuthService.CheckPasswordStrength',
    CompleteMFAEnrollment: 'AuthService.CompleteMFAEnrollment',
    CompleteSSOLogin: 'AuthService.CompleteSSOLogin',
    ConfigureSSO: 'AuthService.ConfigureSSO',
    CreateSSOConnection: 'AuthService.CreateSSOConnection',
    DeleteSSOConnection: 'AuthService.DeleteSSOConnection',
    DisableMFA: 'AuthService.DisableMFA',
    ForgotPassword: 'AuthService.ForgotPassword',
    GetMFAStatus: 'AuthService.GetMFAStatus',
    GetSSOConfig: 'AuthService.GetSSOConfig',
    GetSSOConnection: 'AuthService.GetSSOConnection',
    GetSSOConnectionByDomain: 'AuthService.GetSSOConnectionByDomain',
    GetSSOConnectionByOrganization: 'AuthService.GetSSOConnectionByOrganization',
    ListSSOConnections: 'AuthService.ListSSOConnections',
    ListSessions: 'AuthService.ListSessions',
    Login: 'AuthService.Login',
    LoginWithServiceAccount: 'AuthService.LoginWithServiceAccount',
    Logout: 'AuthService.Logout',
    RefreshToken: 'AuthService.RefreshToken',
    RegenerateMFARecoveryCodes: 'AuthService.RegenerateMFARecoveryCodes',
    RegisterUser: 'AuthService.RegisterUser',
    ResetLoginFailures: 'AuthService.ResetLoginFailures',
    ResetPasswordWithSignature: 'AuthService.ResetPasswordWithSignature',
    RevokeSession: 'AuthService.RevokeSession',
    StartSSOLogin: 'AuthService.StartSSOLogin',
    StartSSOLoginByConnection: 'AuthService.StartSSOLoginByConnection',
    UpdatePassword: 'AuthService.UpdatePassword',
    UpdateSSOConnection: 'AuthService.UpdateSSOConnection',
    VerifyEmail: 'AuthService.VerifyEmail',
    VerifyMFA: 'AuthService.VerifyMFA',
  },
  CallService: {
    AckCall: 'CallService.AckCall',
    CancelCall: 'CallService.CancelCall',
    ClaimCall: 'CallService.ClaimCall',
    CreateCall: 'CallService.CreateCall',
    CreateCallStack: 'CallService.CreateCallStack',
    ExtractOutput: 'CallService.ExtractOutput',
    GenerateAccessToken: 'CallService.GenerateAccessToken',
    GetCall: 'CallService.GetCall',
    GetCallStack: 'CallService.GetCallStack',
    GetCalls: 'CallService.GetCalls',
    GetCaseRecordCalls: 'CallService.GetCaseRecordCalls',
    GetMyUserCalls: 'CallService.GetMyUserCalls',
    GetPayerHours: 'CallService.GetPayerHours',
    ListMyOrganizationCalls: 'CallService.ListMyOrganizationCalls',
    ListStackableCases: 'CallService.ListStackableCases',
    UpdateCall: 'CallService.UpdateCall',
  },
  CampaignService: {
    CreateCampaign: 'CampaignService.CreateCampaign',
    DeleteCampaign: 'CampaignService.DeleteCampaign',
    GetCampaign: 'CampaignService.GetCampaign',
    ListCampaigns: 'CampaignService.ListCampaigns',
  },
  CaseRecordsService: {
    BulkDeleteCaseRecords: 'CaseRecordsService.BulkDeleteCaseRecords',
    CancelCaseRecord: 'CaseRecordsService.CancelCaseRecord',
    CloneCaseRecord: 'CaseRecordsService.CloneCaseRecord',
    CreateCaseRecord: 'CaseRecordsService.CreateCaseRecord',
    CreateCaseRecordWithFax: 'CaseRecordsService.CreateCaseRecordWithFax',
    DeleteCaseRecord: 'CaseRecordsService.DeleteCaseRecord',
    ExecuteAction: 'CaseRecordsService.ExecuteAction',
    ExportCaseRecords: 'CaseRecordsService.ExportCaseRecords',
    FindCaseRecords: 'CaseRecordsService.FindCaseRecords',
    FindOrganizationCaseRecords: 'CaseRecordsService.FindOrganizationCaseRecords',
    GetCaseCounts: 'CaseRecordsService.GetCaseCounts',
    GetCaseRecord: 'CaseRecordsService.GetCaseRecord',
    GetCaseRecordHistory: 'CaseRecordsService.GetCaseRecordHistory',
    GetCaseRecordTimeline: 'CaseRecordsService.GetCaseRecordTimeline',
    GetCurrentUserAssignedCaseRecords: 'CaseRecordsService.GetCurrentUserAssignedCaseRecords',
    GetOrganizationCaseCounts: 'CaseRecordsService.GetOrganizationCaseCounts',
    LinkToCase: 'CaseRecordsService.LinkToCase',
    ListMyOrganizationCases: 'CaseRecordsService.ListMyOrganizationCases',
    MarkAsAdverseEvent: 'CaseRecordsService.MarkAsAdverseEvent',
    MigrateCaseRecordToMedBV: 'CaseRecordsService.MigrateCaseRecordToMedBV',
    SearchCaseRecords: 'CaseRecordsService.SearchCaseRecords',
    StartCaseRecord: 'CaseRecordsService.StartCaseRecord',
    TriggerProcessRecording: 'CaseRecordsService.TriggerProcessRecording',
    UpdateAssigned: 'CaseRecordsService.UpdateAssigned',
    UpdateCaseRecord: 'CaseRecordsService.UpdateCaseRecord',
    UpdateDispositionCode: 'CaseRecordsService.UpdateDispositionCode',
    UpdateInputData: 'CaseRecordsService.UpdateInputData',
    UpdateOutputData: 'CaseRecordsService.UpdateOutputData',
    WatchCaseRecords: 'CaseRecordsService.WatchCaseRecords',
  },
  CasesAnalyticsService: {
    GetCasesAnalytics: 'CasesAnalyticsService.GetCasesAnalytics',
  },
  DispositionService: {
    GetDispositionsByAgentId: 'DispositionService.GetDispositionsByAgentId',
  },
  DrugService: {
    BatchCreateDrugs: 'DrugService.BatchCreateDrugs',
    CreateDrug: 'DrugService.CreateDrug',
    DeleteDrug: 'DrugService.DeleteDrug',
    GetDrug: 'DrugService.GetDrug',
    GetDrugByJCode: 'DrugService.GetDrugByJCode',
    GetDrugByNDC: 'DrugService.GetDrugByNDC',
    GetDrugsBySlug: 'DrugService.GetDrugsBySlug',
    ListDrugs: 'DrugService.ListDrugs',
    SearchDrugsByName: 'DrugService.SearchDrugsByName',
    UpdateDrug: 'DrugService.UpdateDrug',
  },
  EligibilityCheckService: {
    CreateEligibilityCheck: 'EligibilityCheckService.CreateEligibilityCheck',
    GetCaseRecordEligibilityChecks: 'EligibilityCheckService.GetCaseRecordEligibilityChecks',
    GetEligibilityCheck: 'EligibilityCheckService.GetEligibilityCheck',
    UpdateEligibilityCheck: 'EligibilityCheckService.UpdateEligibilityCheck',
  },
  EmailService: {
    CreateEmail: 'EmailService.CreateEmail',
    GetEmail: 'EmailService.GetEmail',
    ListEmailsByCaseID: 'EmailService.ListEmailsByCaseID',
    UpdateEmail: 'EmailService.UpdateEmail',
  },
  EvaluationService: {
    CreateEvaluation: 'EvaluationService.CreateEvaluation',
    GetEvaluation: 'EvaluationService.GetEvaluation',
    GetEvaluationAgents: 'EvaluationService.GetEvaluationAgents',
    GetEvaluationCounts: 'EvaluationService.GetEvaluationCounts',
    GetEvaluationMetadataValues: 'EvaluationService.GetEvaluationMetadataValues',
    ListEvaluations: 'EvaluationService.ListEvaluations',
    UpdateEvaluation: 'EvaluationService.UpdateEvaluation',
  },
  FaxService: {
    CreateFax: 'FaxService.CreateFax',
    DeleteFax: 'FaxService.DeleteFax',
    GetFax: 'FaxService.GetFax',
    ListFaxes: 'FaxService.ListFaxes',
    UpdateFax: 'FaxService.UpdateFax',
  },
  FeedbackInsightService: {
    GetInsightDay: 'FeedbackInsightService.GetInsightDay',
    GetInsightReport: 'FeedbackInsightService.GetInsightReport',
    ListInsightDays: 'FeedbackInsightService.ListInsightDays',
    ListInsightFindings: 'FeedbackInsightService.ListInsightFindings',
    ListInsightRuns: 'FeedbackInsightService.ListInsightRuns',
    ListInsightThemes: 'FeedbackInsightService.ListInsightThemes',
    PublishInsightReport: 'FeedbackInsightService.PublishInsightReport',
    PutInsightRun: 'FeedbackInsightService.PutInsightRun',
    SaveInsightReport: 'FeedbackInsightService.SaveInsightReport',
    SetInsightFixReview: 'FeedbackInsightService.SetInsightFixReview',
  },
  FeedbackService: {
    DeleteFeedback: 'FeedbackService.DeleteFeedback',
    GetFeedback: 'FeedbackService.GetFeedback',
    ListFeedback: 'FeedbackService.ListFeedback',
    SubmitFeedback: 'FeedbackService.SubmitFeedback',
    UpdateFeedback: 'FeedbackService.UpdateFeedback',
  },
  GenericTaskService: {
    CreateGenericTask: 'GenericTaskService.CreateGenericTask',
    GetGenericTask: 'GenericTaskService.GetGenericTask',
    GetGenericTasks: 'GenericTaskService.GetGenericTasks',
    UpdateGenericTask: 'GenericTaskService.UpdateGenericTask',
  },
  IngestionService: {
    CreateIngestion: 'IngestionService.CreateIngestion',
    GetIngestion: 'IngestionService.GetIngestion',
    ListIngestions: 'IngestionService.ListIngestions',
    SetIngestionInput: 'IngestionService.SetIngestionInput',
    SetIngestionStartTime: 'IngestionService.SetIngestionStartTime',
  },
  IntentsService: {
    CreateIntent: 'IntentsService.CreateIntent',
    ResolveIntent: 'IntentsService.ResolveIntent',
  },
  MailboxService: {
    BulkDeleteMailboxMessages: 'MailboxService.BulkDeleteMailboxMessages',
    DeleteAdminMailboxMessage: 'MailboxService.DeleteAdminMailboxMessage',
    DeleteMailboxMessage: 'MailboxService.DeleteMailboxMessage',
    GetAdminMailboxInbox: 'MailboxService.GetAdminMailboxInbox',
    GetAdminMailboxMessage: 'MailboxService.GetAdminMailboxMessage',
    GetMailboxInbox: 'MailboxService.GetMailboxInbox',
    GetMailboxMessage: 'MailboxService.GetMailboxMessage',
    GetMailboxUnreadCount: 'MailboxService.GetMailboxUnreadCount',
    PurgeAdminMailboxMessages: 'MailboxService.PurgeAdminMailboxMessages',
    SendMailboxMessage: 'MailboxService.SendMailboxMessage',
    SendUserMailboxMessage: 'MailboxService.SendUserMailboxMessage',
    StreamMailboxNotifications: 'MailboxService.StreamMailboxNotifications',
    UpdateAdminMailboxMessageFlags: 'MailboxService.UpdateAdminMailboxMessageFlags',
    UpdateMailboxMessageFlags: 'MailboxService.UpdateMailboxMessageFlags',
  },
  ManualActionService: {
    ExecuteAttachToCaseAction: 'ManualActionService.ExecuteAttachToCaseAction',
    ExecuteAuditAction: 'ManualActionService.ExecuteAuditAction',
    ExecuteAwaitingReviewAction: 'ManualActionService.ExecuteAwaitingReviewAction',
    ExecuteCallAction: 'ManualActionService.ExecuteCallAction',
    ExecuteEligibilityCheckAuditAction: 'ManualActionService.ExecuteEligibilityCheckAuditAction',
    ExecuteEmailExchangeAction: 'ManualActionService.ExecuteEmailExchangeAction',
    ExecuteFillMissingInfoAction: 'ManualActionService.ExecuteFillMissingInfoAction',
    ExecuteIntakeDraftAction: 'ManualActionService.ExecuteIntakeDraftAction',
    ExecutePortalSessionAction: 'ManualActionService.ExecutePortalSessionAction',
    ExecuteRegenerateCaseSummaryAction: 'ManualActionService.ExecuteRegenerateCaseSummaryAction',
    ExecuteResendEmailAction: 'ManualActionService.ExecuteResendEmailAction',
    ExecuteReviewAction: 'ManualActionService.ExecuteReviewAction',
  },
  ManualTaskService: {
    CountMyManualTasks: 'ManualTaskService.CountMyManualTasks',
    CreateManualTask: 'ManualTaskService.CreateManualTask',
    DeleteManualTask: 'ManualTaskService.DeleteManualTask',
    GetManualTask: 'ManualTaskService.GetManualTask',
    ListCaseManualTasks: 'ManualTaskService.ListCaseManualTasks',
    ListManualTasks: 'ManualTaskService.ListManualTasks',
    ListMyManualTasks: 'ManualTaskService.ListMyManualTasks',
    ListOrganizationManualTasks: 'ManualTaskService.ListOrganizationManualTasks',
    UpdateManualTask: 'ManualTaskService.UpdateManualTask',
  },
  MetadataRegistryService: {
    CreateMetadataRegistryEntry: 'MetadataRegistryService.CreateMetadataRegistryEntry',
    DeleteMetadataRegistryEntry: 'MetadataRegistryService.DeleteMetadataRegistryEntry',
    GetMetadataRegistryEntry: 'MetadataRegistryService.GetMetadataRegistryEntry',
    ListMetadataRegistryEntries: 'MetadataRegistryService.ListMetadataRegistryEntries',
    UpdateMetadataRegistryEntry: 'MetadataRegistryService.UpdateMetadataRegistryEntry',
  },
  NoteService: {
    CreateNote: 'NoteService.CreateNote',
    ListNotes: 'NoteService.ListNotes',
  },
  OrgKeyService: {
    CreateOrgKey: 'OrgKeyService.CreateOrgKey',
    DeleteOrgKey: 'OrgKeyService.DeleteOrgKey',
    ListOrgKeys: 'OrgKeyService.ListOrgKeys',
    RotateOrgKey: 'OrgKeyService.RotateOrgKey',
  },
  OrganizationRoleService: {
    ListOrganizationRoles: 'OrganizationRoleService.ListOrganizationRoles',
  },
  OrganizationTeamService: {
    CreateOrganizationTeam: 'OrganizationTeamService.CreateOrganizationTeam',
    DeleteOrganizationTeam: 'OrganizationTeamService.DeleteOrganizationTeam',
    GetOrganizationTeam: 'OrganizationTeamService.GetOrganizationTeam',
    ListOrganizationTeams: 'OrganizationTeamService.ListOrganizationTeams',
    UpdateOrganizationTeam: 'OrganizationTeamService.UpdateOrganizationTeam',
  },
  OrganizationUserRoleService: {
    AddOrganizationUserRole: 'OrganizationUserRoleService.AddOrganizationUserRole',
    ChangeOrganizationUserRole: 'OrganizationUserRoleService.ChangeOrganizationUserRole',
    GetOrganizationUserRoles: 'OrganizationUserRoleService.GetOrganizationUserRoles',
    RemoveOrganizationUserRole: 'OrganizationUserRoleService.RemoveOrganizationUserRole',
  },
  OrganizationUserService: {
    SearchOrganizationUsers: 'OrganizationUserService.SearchOrganizationUsers',
  },
  OrganizationsService: {
    AddUserToOrganization: 'OrganizationsService.AddUserToOrganization',
    CreateOrganization: 'OrganizationsService.CreateOrganization',
    DeleteOrganization: 'OrganizationsService.DeleteOrganization',
    DeleteOrganizationInvitation: 'OrganizationsService.DeleteOrganizationInvitation',
    GetCurrentUserOrganizations: 'OrganizationsService.GetCurrentUserOrganizations',
    GetOrganization: 'OrganizationsService.GetOrganization',
    GetOrganizationInvitation: 'OrganizationsService.GetOrganizationInvitation',
    GetOrganizationMembers: 'OrganizationsService.GetOrganizationMembers',
    GetOrganizations: 'OrganizationsService.GetOrganizations',
    InviteUserToOrganization: 'OrganizationsService.InviteUserToOrganization',
    ListOrganizationInvitations: 'OrganizationsService.ListOrganizationInvitations',
    RemoveUserFromOrganization: 'OrganizationsService.RemoveUserFromOrganization',
    UpdateOrganization: 'OrganizationsService.UpdateOrganization',
  },
  PMSService: {
    GetPmsPatientPrefill: 'PMSService.GetPmsPatientPrefill',
    SearchPmsPatients: 'PMSService.SearchPmsPatients',
  },
  PayorService: {
    CreatePayor: 'PayorService.CreatePayor',
    GetPayor: 'PayorService.GetPayor',
    GetPayorBySlug: 'PayorService.GetPayorBySlug',
    GetPayorByStediId: 'PayorService.GetPayorByStediId',
    ListPayors: 'PayorService.ListPayors',
    SearchPayorsByName: 'PayorService.SearchPayorsByName',
    UpdatePayor: 'PayorService.UpdatePayor',
  },
  PhoneNumberService: {
    AddProgramPhoneNumber: 'PhoneNumberService.AddProgramPhoneNumber',
    CreatePhoneNumber: 'PhoneNumberService.CreatePhoneNumber',
    DeletePhoneNumber: 'PhoneNumberService.DeletePhoneNumber',
    ListPhoneNumbers: 'PhoneNumberService.ListPhoneNumbers',
    ListProgramPhoneNumbers: 'PhoneNumberService.ListProgramPhoneNumbers',
    RemoveProgramPhoneNumber: 'PhoneNumberService.RemoveProgramPhoneNumber',
    UpdatePhoneNumber: 'PhoneNumberService.UpdatePhoneNumber',
  },
  PolicyService: {
    AddPolicyRule: 'PolicyService.AddPolicyRule',
    ClonePolicy: 'PolicyService.ClonePolicy',
    CreatePolicy: 'PolicyService.CreatePolicy',
    GetPolicy: 'PolicyService.GetPolicy',
    ListPoliciesByProgram: 'PolicyService.ListPoliciesByProgram',
    RemovePolicyRule: 'PolicyService.RemovePolicyRule',
    UpdatePolicy: 'PolicyService.UpdatePolicy',
  },
  ProgramRoleService: {
    ListProgramRoles: 'ProgramRoleService.ListProgramRoles',
  },
  ProgramService: {
    CloneProgram: 'ProgramService.CloneProgram',
    CreateProgram: 'ProgramService.CreateProgram',
    DownloadProgramCaseRecords: 'ProgramService.DownloadProgramCaseRecords',
    GetCurrentUserPrograms: 'ProgramService.GetCurrentUserPrograms',
    GetProgram: 'ProgramService.GetProgram',
    GetPrograms: 'ProgramService.GetPrograms',
    UpdateProgram: 'ProgramService.UpdateProgram',
  },
  ProgramTeamService: {
    GetProgramTeam: 'ProgramTeamService.GetProgramTeam',
    ListProgramTeams: 'ProgramTeamService.ListProgramTeams',
  },
  ProgramUserRoleService: {
    AddProgramUserRole: 'ProgramUserRoleService.AddProgramUserRole',
    ChangeProgramUserRole: 'ProgramUserRoleService.ChangeProgramUserRole',
    GetProgramUserRoles: 'ProgramUserRoleService.GetProgramUserRoles',
    RemoveProgramUserRole: 'ProgramUserRoleService.RemoveProgramUserRole',
  },
  ProgramUserService: {
    SearchProgramUsers: 'ProgramUserService.SearchProgramUsers',
  },
  RoleService: {
    AddPermissionToRole: 'RoleService.AddPermissionToRole',
    CloneRole: 'RoleService.CloneRole',
    CreateRole: 'RoleService.CreateRole',
    DeleteRole: 'RoleService.DeleteRole',
    GetRole: 'RoleService.GetRole',
    ListRoles: 'RoleService.ListRoles',
    ReloadRoleCache: 'RoleService.ReloadRoleCache',
    RemovePermissionFromRole: 'RoleService.RemovePermissionFromRole',
    SearchRoles: 'RoleService.SearchRoles',
    UpdateRole: 'RoleService.UpdateRole',
  },
  SchemaService: {
    GetSchema: 'SchemaService.GetSchema',
    ListSchemaVersions: 'SchemaService.ListSchemaVersions',
  },
  ScorecardService: {
    BackfillScorecardMetadataKeys: 'ScorecardService.BackfillScorecardMetadataKeys',
    CreateScorecard: 'ScorecardService.CreateScorecard',
    DeleteScorecard: 'ScorecardService.DeleteScorecard',
    GetScorecard: 'ScorecardService.GetScorecard',
    ListScorecards: 'ScorecardService.ListScorecards',
    UpdateScorecard: 'ScorecardService.UpdateScorecard',
  },
  ScriptService: {
    CreateScript: 'ScriptService.CreateScript',
    DeleteScript: 'ScriptService.DeleteScript',
    GetActiveScript: 'ScriptService.GetActiveScript',
    GetOutputSchema: 'ScriptService.GetOutputSchema',
    GetScript: 'ScriptService.GetScript',
    ListScripts: 'ScriptService.ListScripts',
    UpdateScript: 'ScriptService.UpdateScript',
  },
  ServiceAccountService: {
    CreateServiceAccount: 'ServiceAccountService.CreateServiceAccount',
    DeleteServiceAccount: 'ServiceAccountService.DeleteServiceAccount',
    GetServiceAccount: 'ServiceAccountService.GetServiceAccount',
    ListServiceAccounts: 'ServiceAccountService.ListServiceAccounts',
    RotateServiceAccountSecret: 'ServiceAccountService.RotateServiceAccountSecret',
    UpdateServiceAccount: 'ServiceAccountService.UpdateServiceAccount',
  },
  SummaryService: {
    GetCallSummaries: 'SummaryService.GetCallSummaries',
    GetCaseSummary: 'SummaryService.GetCaseSummary',
    RegenerateSummary: 'SummaryService.RegenerateSummary',
    UpdateSummary: 'SummaryService.UpdateSummary',
  },
  TeamService: {
    CreateTeam: 'TeamService.CreateTeam',
    DeleteTeam: 'TeamService.DeleteTeam',
    GetCurrentUserTeams: 'TeamService.GetCurrentUserTeams',
    GetTeam: 'TeamService.GetTeam',
    ListTeams: 'TeamService.ListTeams',
    UpdateTeam: 'TeamService.UpdateTeam',
  },
  TemplateService: {
    CreateTemplate: 'TemplateService.CreateTemplate',
    DeleteTemplate: 'TemplateService.DeleteTemplate',
    GetTemplate: 'TemplateService.GetTemplate',
    ListTemplates: 'TemplateService.ListTemplates',
    RenderTemplate: 'TemplateService.RenderTemplate',
    UpdateTemplate: 'TemplateService.UpdateTemplate',
  },
  TextService: {
    CreateText: 'TextService.CreateText',
    GetText: 'TextService.GetText',
    GetTexts: 'TextService.GetTexts',
    UpdateText: 'TextService.UpdateText',
  },
  UserRoleService: {
    AddUserRole: 'UserRoleService.AddUserRole',
    ChangeUserRole: 'UserRoleService.ChangeUserRole',
    CheckMyPermissions: 'UserRoleService.CheckMyPermissions',
    GetMyRoles: 'UserRoleService.GetMyRoles',
    ListUserRoles: 'UserRoleService.ListUserRoles',
    RemoveUserRole: 'UserRoleService.RemoveUserRole',
  },
  UserService: {
    CreateUser: 'UserService.CreateUser',
    DeleteUser: 'UserService.DeleteUser',
    GetCurrentUser: 'UserService.GetCurrentUser',
    GetCurrentUserSkills: 'UserService.GetCurrentUserSkills',
    GetMyAvailability: 'UserService.GetMyAvailability',
    GetUser: 'UserService.GetUser',
    GetUserSkills: 'UserService.GetUserSkills',
    HeartbeatMyAvailability: 'UserService.HeartbeatMyAvailability',
    LookupUsers: 'UserService.LookupUsers',
    SearchUsers: 'UserService.SearchUsers',
    SetMyAvailability: 'UserService.SetMyAvailability',
    SetPassword: 'UserService.SetPassword',
    SetUserSkills: 'UserService.SetUserSkills',
    UpdateCurrentUser: 'UserService.UpdateCurrentUser',
    UpdateUser: 'UserService.UpdateUser',
  },
  WebhookService: {
    BulkRetryWebhookDeliveries: 'WebhookService.BulkRetryWebhookDeliveries',
    CreateWebhookEndpoint: 'WebhookService.CreateWebhookEndpoint',
    DeleteWebhookEndpoint: 'WebhookService.DeleteWebhookEndpoint',
    DisableWebhookEndpoint: 'WebhookService.DisableWebhookEndpoint',
    GetWebhookDelivery: 'WebhookService.GetWebhookDelivery',
    GetWebhookEndpoint: 'WebhookService.GetWebhookEndpoint',
    GetWebhookEndpointHealth: 'WebhookService.GetWebhookEndpointHealth',
    GetWebhookOperation: 'WebhookService.GetWebhookOperation',
    ListWebhookDeliveries: 'WebhookService.ListWebhookDeliveries',
    ListWebhookEndpoints: 'WebhookService.ListWebhookEndpoints',
    PauseWebhookEndpoint: 'WebhookService.PauseWebhookEndpoint',
    ReplayWebhookWindow: 'WebhookService.ReplayWebhookWindow',
    ResumeWebhookEndpoint: 'WebhookService.ResumeWebhookEndpoint',
    RetryWebhookDelivery: 'WebhookService.RetryWebhookDelivery',
    RotateWebhookEndpointSecret: 'WebhookService.RotateWebhookEndpointSecret',
    SendWebhookTestEvent: 'WebhookService.SendWebhookTestEvent',
    UpdateWebhookEndpoint: 'WebhookService.UpdateWebhookEndpoint',
  },
  WorkflowService: {
    CloneWorkflow: 'WorkflowService.CloneWorkflow',
    CreateWorkflow: 'WorkflowService.CreateWorkflow',
    GetWorkflow: 'WorkflowService.GetWorkflow',
    GetWorkflowsByProgram: 'WorkflowService.GetWorkflowsByProgram',
    ListOrganizationWorkflows: 'WorkflowService.ListOrganizationWorkflows',
    UpdateWorkflow: 'WorkflowService.UpdateWorkflow',
  },
} as const;
